<template>
  <ul class="setting_list" :style="`width: ${width}px`">
    <li v-report:mainclick="{ area: 'set', pos: 3 }" class="setting_item" @click="clickHandle(0)">关闭</li>
    <li v-report:mainclick="{ area: 'set', pos: 0 }" class="setting_item" @click="clickHandle(1)">设置</li>
    <li v-report:mainclick="{ area: 'set', pos: 1 }" class="setting_item" @click="clickHandle(2)">客服</li>
    <li
      v-report:mainclick="{ area: 'set', pos: 2 }" v-unshow:[unshowMap.feedback] class="setting_item"
      @click="clickHandle(3)">反馈</li>
  </ul>
</template>

<script>
import {
  ClientCloseSelf, ClientFeedback, ClientOpenBrowser
} from '@/api/clientApi.js'
import { UrlCustomer } from '@/common/resources.js'
import { unshowMap } from '@/common/const.js'

export default {
  name: 'ToolsSettingList',

  props: {
    width: {
      type: Number,
      default: 76
    }
  },

  data () {
    return { unshowMap }
  },

  methods: {
    clickHandle (index) {
      this.$emit('selectIndex', index)

      switch (index) {
        case 0:
          ClientCloseSelf()
          break
        case 2:
          ClientOpenBrowser(UrlCustomer)
          break
        case 3:
          ClientFeedback()
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.setting_list { position: absolute; top: 38px; left: -23px; z-index: 1; padding: 5px 0; font-size: 16px; font-weight: 400; color: $font_color_5; text-align: center; background-color: #fff; box-shadow: $box_shadow_2;
  .setting_item { height: 30px; line-height: 30px; cursor: pointer;
    &:hover { font-weight: bold; color: $font_color_8; background-color: #e0e2e9; }
  }
}
</style>
